import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M19.2 4.8V16.5C14.484 16.5 15.978 16.5 13.854 16.5C13.197 17.724 13.494 17.211 12.396 19.02C12.297 19.164 12.162 19.227 12.063 19.227C11.964 19.227 11.829 19.209 11.739 19.065C11.235 18.336 11.523 18.822 10.29 16.5C8.09401 16.5 9.678 16.5 4.791 16.5V4.8H19.2ZM21 3H3V18.3H9.345C10.065 19.65 10.551 21 12.072 21C13.674 21 13.935 19.902 14.808 18.3H21V3Z' />
        </SvgIcon>
    );
});
